import { msg } from "@lingui/core/macro";
import { Trans } from "@lingui/react/macro";
import { useLingui } from "@lingui/react";
import {
  Modal,
  ModalBody,
  ModalContent,
  ModalTrigger,
  Text,
} from "@wootingkb/component-library";

const COUPON_CODE_LOCATION_ALT = msg({
  id: "Coupon_code_location_alt",
  message: "code location",
});

export function CouponUseModal() {
  const { _: i18n } = useLingui();

  return (
    <Modal>
      <ModalTrigger asChild>
        <Text
          size="sm"
          className="cursor-pointer text-foreground-secondary underline"
        >
          <Trans id="Coupon_how_to_use_discount_link">
            How to use this discount?
          </Trans>
        </Text>
      </ModalTrigger>
      <ModalContent
        size="2xl"
        className="max-h-full overflow-y-auto md:max-h-[90vh]"
      >
        <ModalBody
          title={
            <Trans id="Coupon_how_to_use_discount_title">
              How to use a discount code
            </Trans>
          }
        >
          <Text>
            <Trans id="Coupon_how_to_use_discount_checkout">
              During the checkout step where you have to fill in your personal
              information (name, address, etc), on the right side there is a
              field where you can paste and apply the discount code.
            </Trans>
          </Text>
          <Text>
            <Trans id="Coupon_how_to_use_discount_mobile">
              On mobile the discount code input field is located under the
              “Order summary”.
            </Trans>
          </Text>
          <img
            src="https://wooting-web-files.ams3.cdn.digitaloceanspaces.com/public/code.png"
            alt={i18n(COUPON_CODE_LOCATION_ALT)}
            className="w-full rounded-default"
          />
        </ModalBody>
      </ModalContent>
    </Modal>
  );
}
